/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.video.startUpload'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  sizeBytes: /*#__PURE__*/ l.integer({ minimum: 1 }),
  mimeType: /*#__PURE__*/ l.string({ minLength: 3, maxLength: 255 }),
  name: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ maxLength: 256 })),
  durationMs: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
  width: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
  height: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  jobId: /*#__PURE__*/ l.string({ minLength: 1, maxLength: 256 }),
  partSizeBytes: /*#__PURE__*/ l.integer(),
  partCount: /*#__PURE__*/ l.integer(),
  expiresAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Start a multipart video upload. The declared size is exact, while optional media properties are advisory and used only for early failure; the authoritative probe runs asynchronously after upload. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'UnsupportedContentType',
  'VideoTooLarge',
  'VideoTooLong',
  'BadAspectRatio',
  'DailyLimitExceeded',
  'TooManyOpenUploads',
  'UploadForbidden',
  'ServiceOverloaded',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
